import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../assets/image/info.png'
import _imports_1 from '../assets/image/desc.png'
import _imports_2 from '../assets/image/edit.png'
import _imports_3 from '../assets/image/ok.png'
import _imports_4 from '../assets/image/hts.png'


const _hoisted_1 = { class: "hts-content" }
const _hoisted_2 = { style: {"background-color":"#f5f5f5","padding":"24px 24px 24px 24px","height":"-webkit-fill-available"} }
const _hoisted_3 = { style: {"background-color":"#ffffff","height":"-webkit-fill-available"} }
const _hoisted_4 = {
  class: "bread-cls",
  style: {"background-color":"#f5f5f5"}
}
const _hoisted_5 = { style: {"margin":"24px 24px 12px 24px","font-size":"16px","font-weight":"600"} }
const _hoisted_6 = { class: "group-check-hts" }
const _hoisted_7 = { style: {"position":"relative","top":"-4px"} }
const _hoisted_8 = { class: "replace_line" }
const _hoisted_9 = { class: "replace_btn" }
const _hoisted_10 = { class: "replace_AI" }
const _hoisted_11 = { class: "hts-table" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "hts-description-detail" }
const _hoisted_21 = { class: "hts-drawer" }
const _hoisted_22 = { style: {"display":"flex"} }
const _hoisted_23 = { style: {"display":"flex","gap":"8px"} }
const _hoisted_24 = { style: {"display":"flex"} }
const _hoisted_25 = { style: {"display":"flex","gap":"8px"} }
const _hoisted_26 = {
  key: 0,
  class: "rule-label"
}
const _hoisted_27 = {
  key: 1,
  class: "rule-label"
}
const _hoisted_28 = {
  key: 2,
  class: "rule-label"
}
const _hoisted_29 = {
  key: 3,
  class: "rule-label"
}
const _hoisted_30 = {
  key: 4,
  class: "rule-label"
}
const _hoisted_31 = {
  key: 0,
  class: "rule-info-detail"
}
const _hoisted_32 = {
  key: 1,
  class: "rule-info-detail"
}
const _hoisted_33 = {
  key: 2,
  class: "rule-info-detail"
}
const _hoisted_34 = { class: "hts-description-detail" }
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { key: 1 }
const _hoisted_40 = { style: {"margin-top":"8px"} }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = { class: "suggest-hts" }
const _hoisted_43 = {
  key: 0,
  class: "hts-modal-table",
  style: {"margin-top":"24px"}
}
const _hoisted_44 = {
  class: "hts-modal-content",
  style: {"margin-top":"16px"}
}
const _hoisted_45 = { key: 0 }
const _hoisted_46 = { key: 1 }
const _hoisted_47 = { class: "hts-description-detail" }
const _hoisted_48 = { key: 0 }
const _hoisted_49 = { key: 1 }
const _hoisted_50 = { key: 1 }
const _hoisted_51 = {
  class: "hts-form",
  style: {"margin-top":"24px"}
}
const _hoisted_52 = { key: 0 }
const _hoisted_53 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TopBar = _resolveComponent("TopBar")!
  const _component_a_breadcrumb_item = _resolveComponent("a-breadcrumb-item")!
  const _component_a_breadcrumb = _resolveComponent("a-breadcrumb")!
  const _component_a_checkbox_group = _resolveComponent("a-checkbox-group")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_badge = _resolveComponent("a-badge")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!
  const _component_a_drawer = _resolveComponent("a-drawer")!
  const _component_LinkOutlined = _resolveComponent("LinkOutlined")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_segmented = _resolveComponent("a-segmented")!
  const _component_a_progress = _resolveComponent("a-progress")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_TopBar),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_a_breadcrumb, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_breadcrumb_item, null, {
                default: _withCtx(() => [
                  _createElementVNode("a", {
                    href: "javascript:void(0)",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.backToT86 && _ctx.backToT86(...args)))
                  }, "T86")
                ]),
                _: 1
              }),
              _createVNode(_component_a_breadcrumb_item, null, {
                default: _withCtx(() => _cache[20] || (_cache[20] = [
                  _createTextVNode("HTS Check")
                ])),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.masterBillNumber), 1),
        _createVNode(_component_a_spin, { spinning: _ctx.loadingType }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_a_checkbox_group, {
                value: _ctx.checkedHtsStatus,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.checkedHtsStatus) = $event)),
                options: _ctx.checkStatusOption,
                name: "hts-select",
                style: {"gap":"32px"},
                onChange: _ctx.statusCheckHandle
              }, {
                label: _withCtx((option) => [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("span", null, _toDisplayString(option.label), 1),
                    _createElementVNode("span", {
                      style: _normalizeStyle({ color: option.color, 'margin-left': '4px','font-size' : '24px'})
                    }, _toDisplayString(option.num), 5)
                  ])
                ]),
                _: 1
              }, 8, ["value", "options", "onChange"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: _ctx.replaceByRuleHandle
                }, {
                  default: _withCtx(() => _cache[21] || (_cache[21] = [
                    _createTextVNode("Replace by rules")
                  ])),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _cache[22] || (_cache[22] = _createElementVNode("label", null, "Intelligent Replace", -1)),
                _createVNode(_component_a_switch, {
                  checked: _ctx.aiChecked,
                  "onUpdate:checked": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.aiChecked) = $event)),
                  size: "small",
                  disabled: !_ctx.hasReplace
                }, null, 8, ["checked", "disabled"])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_a_table, {
                dataSource: _ctx.dataSource,
                columns: _ctx.columnsInfo,
                pagination: _ctx.pageData,
                onChange: _ctx.tableChangeHandle
              }, {
                bodyCell: _withCtx(({ column, record }) => [
                  (column.key === 'PGA Flag')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (record.pgaFlags.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.pgaFlags, (tag) => {
                                return (_openBlock(), _createBlock(_component_a_tag, {
                                  key: tag.title,
                                  color: tag.color
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(tag.title), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["color"]))
                              }), 128))
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_13, "-"))
                      ], 64))
                    : (column.key === 'Description Flag')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          (record.descriptionFlags.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.descriptionFlags, (tag) => {
                                  return (_openBlock(), _createBlock(_component_a_tag, {
                                    key: tag.title,
                                    color: tag.color
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(tag.title), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["color"]))
                                }), 128))
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_15, "-"))
                        ], 64))
                      : (column.key === 'Valid')
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(record.status, (name) => {
                            return (_openBlock(), _createElementBlock("div", { key: name }, [
                              (name === 'Invalid')
                                ? (_openBlock(), _createBlock(_component_a_badge, {
                                    key: 0,
                                    color: "red"
                                  }))
                                : (name === 'HTS Warning')
                                  ? (_openBlock(), _createBlock(_component_a_badge, {
                                      key: 1,
                                      color: "orange"
                                    }))
                                  : (name === 'Description Warning')
                                    ? (_openBlock(), _createBlock(_component_a_badge, {
                                        key: 2,
                                        color: "yellow"
                                      }))
                                    : (_openBlock(), _createBlock(_component_a_badge, {
                                        key: 3,
                                        color: "green"
                                      })),
                              _createElementVNode("label", null, _toDisplayString(name), 1)
                            ]))
                          }), 128))
                        : (column.key === 'actions')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                              (_ctx.aiChecked)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                    _createElementVNode("a", {
                                      href: "javascript:void(0)",
                                      onClick: ($event: any) => (_ctx.getRecommond(record))
                                    }, "Edit", 8, _hoisted_17),
                                    (record.descriptionFlags.length > 0)
                                      ? (_openBlock(), _createBlock(_component_a_divider, {
                                          key: 0,
                                          type: "vertical"
                                        }))
                                      : _createCommentVNode("", true),
                                    (record.descriptionFlags.length > 0)
                                      ? (_openBlock(), _createElementBlock("a", {
                                          key: 1,
                                          href: "javascript:void(0)",
                                          onClick: ($event: any) => (_ctx.believeHandle(record))
                                        }, "Skip", 8, _hoisted_18))
                                      : _createCommentVNode("", true)
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_19, "-"))
                            ], 64))
                          : (column.key === 'HTS Description')
                            ? (_openBlock(), _createBlock(_component_a_tooltip, {
                                key: 4,
                                trigger: "click",
                                placement: "topLeft"
                              }, {
                                title: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(record.htsDescription), 1)
                                ]),
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_20, _toDisplayString(record.htsDescription), 1)
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["dataSource", "columns", "pagination", "onChange"])
            ])
          ]),
          _: 1
        }, 8, ["spinning"]),
        _createElementVNode("div", _hoisted_21, [
          _createVNode(_component_a_drawer, {
            width: "750",
            title: "Edit",
            closable: true,
            maskClosable: false,
            open: _ctx.drawerShow,
            destroyOnClose: true,
            onClose: _ctx.onClose
          }, {
            extra: _withCtx(() => [
              _createElementVNode("div", _hoisted_22, [
                _cache[25] || (_cache[25] = _createElementVNode("div", { style: {"flex":"1"} }, null, -1)),
                _createElementVNode("div", _hoisted_23, [
                  _createVNode(_component_a_button, {
                    loading: _ctx.saveLoading,
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.saveHandle(false)))
                  }, {
                    default: _withCtx(() => _cache[23] || (_cache[23] = [
                      _createTextVNode("Save")
                    ])),
                    _: 1
                  }, 8, ["loading"]),
                  _createVNode(_component_a_button, {
                    loading: _ctx.saveLoading,
                    type: "primary",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.saveHandle(true)))
                  }, {
                    default: _withCtx(() => _cache[24] || (_cache[24] = [
                      _createTextVNode("Submit And Save Rules")
                    ])),
                    _: 1
                  }, 8, ["loading"])
                ])
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_a_spin, {
                spinning: _ctx.saveLoading,
                style: {"z-index":"1050"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_drawer, {
                    open: _ctx.ruleDrawer,
                    "onUpdate:open": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.ruleDrawer) = $event)),
                    width: "500",
                    maskClosable: false,
                    title: "Choose Save Rules",
                    closable: true
                  }, {
                    extra: _withCtx(() => [
                      _createElementVNode("div", _hoisted_24, [
                        _cache[27] || (_cache[27] = _createElementVNode("div", { style: {"flex":"1"} }, null, -1)),
                        _createElementVNode("div", _hoisted_25, [
                          _createVNode(_component_a_button, {
                            loading: _ctx.saveLoading,
                            type: "primary",
                            onClick: _ctx.saveAndRuleHandle
                          }, {
                            default: _withCtx(() => _cache[26] || (_cache[26] = [
                              _createTextVNode("Submit")
                            ])),
                            _: 1
                          }, 8, ["loading", "onClick"])
                        ])
                      ])
                    ]),
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ruleData, (rule) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: rule.saveRule,
                          style: {"margin-bottom":"24px"}
                        }, [
                          _createElementVNode("div", null, [
                            _createVNode(_component_a_radio, {
                              checked: _ctx.selectRule.saveRule === rule.saveRule,
                              value: rule.saveRule,
                              onChange: ($event: any) => (_ctx.onRuleRadioChange(rule))
                            }, null, 8, ["checked", "value", "onChange"]),
                            (rule.saveRule===1)
                              ? (_openBlock(), _createElementBlock("label", _hoisted_26, "Replace HTS Code"))
                              : (rule.saveRule === 2)
                                ? (_openBlock(), _createElementBlock("label", _hoisted_27, "Replace Description"))
                                : (rule.saveRule === 3 && rule.newDescription == rule.originalDescription)
                                  ? (_openBlock(), _createElementBlock("label", _hoisted_28, "Replace HTS Code Where Description"))
                                  : (rule.saveRule === 3 && rule.newHtsCode == rule.originalHtsCode)
                                    ? (_openBlock(), _createElementBlock("label", _hoisted_29, "Replace Description Where HTS Code"))
                                    : (rule.saveRule ===3 && rule.newHtsCode != rule.originalHtsCode && rule.newDescription != rule.originalDescription)
                                      ? (_openBlock(), _createElementBlock("label", _hoisted_30, "Replace HTS Code And Description"))
                                      : _createCommentVNode("", true)
                          ]),
                          (rule.saveRule === 1)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                _createVNode(_component_a_descriptions, {
                                  layout: "vertical",
                                  size: "small",
                                  labelStyle: {'color': '#000000A6', 'font-weight' : 400, height: '14px'},
                                  contentStyle: { 'display': '-webkit-box', 'font-weight' : 400,'WebkitBoxOrient': 'vertical', 'WebkitLineClamp': 2, 'overflow': 'hidden', 'textOverflow': 'ellipsis' },
                                  column: { xxl: 2, xl: 2, lg: 2, md: 2, sm: 2, xs: 1 }
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_descriptions_item, { label: "HTS Code" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(rule.originalHtsCode), 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_a_descriptions_item, { label: "New HTS Code" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(rule.newHtsCode), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]))
                            : _createCommentVNode("", true),
                          (rule.saveRule === 2)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                _createVNode(_component_a_descriptions, {
                                  layout: "vertical",
                                  size: "small",
                                  labelStyle: {'color': '#000000A6', 'font-weight' : 400},
                                  contentStyle: { 'display': '-webkit-box', 'font-weight' : 400,'WebkitBoxOrient': 'vertical', 'WebkitLineClamp': 2, 'overflow': 'hidden', 'textOverflow': 'ellipsis' },
                                  column: { xxl: 2, xl: 2, lg: 2, md: 2, sm: 2, xs: 1 }
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_descriptions_item, {
                                      label: "Shipment Description",
                                      span: 2
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(rule.originalDescription), 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_a_descriptions_item, {
                                      label: "New Shipment Description",
                                      span: 2
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(rule.newDescription), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]))
                            : _createCommentVNode("", true),
                          (rule.saveRule === 3)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                _createVNode(_component_a_descriptions, {
                                  layout: "vertical",
                                  size: "small",
                                  labelStyle: {'color': '#000000A6', 'font-weight' : 400},
                                  contentStyle: { 'display': '-webkit-box', 'font-weight' : 400,'WebkitBoxOrient': 'vertical', 'WebkitLineClamp': 2, 'overflow': 'hidden', 'textOverflow': 'ellipsis' },
                                  column: { xxl: 2, xl: 2, lg: 2, md: 2, sm: 2, xs: 1 }
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_descriptions_item, { label: "HTS Code" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(rule.originalHtsCode), 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    (rule.originalHtsCode !== rule.newHtsCode)
                                      ? (_openBlock(), _createBlock(_component_a_descriptions_item, {
                                          key: 0,
                                          label: "New HTS Code"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(rule.newHtsCode), 1)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      : _createCommentVNode("", true),
                                    _createVNode(_component_a_descriptions_item, {
                                      label: "Shipment Description",
                                      span: 2
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(rule.originalDescription), 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    (rule.originalDescription !== rule.newDescription)
                                      ? (_openBlock(), _createBlock(_component_a_descriptions_item, {
                                          key: 1,
                                          label: "New Shipment Description",
                                          span: 2
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(rule.newDescription), 1)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["open"]),
                  _createVNode(_component_a_descriptions, {
                    dataSource: _ctx.itemData,
                    layout: "vertical",
                    size: "small",
                    labelStyle: {'color': '#000000A6', 'font-weight' : 400, height: '14px'},
                    contentStyle: { 'display': '-webkit-box', 'font-weight' : 400,'WebkitBoxOrient': 'vertical', 'WebkitLineClamp': 2, 'overflow': 'hidden', 'textOverflow': 'ellipsis' },
                    column: { xxl: 3, xl: 3, lg: 3, md: 3, sm: 2, xs: 1 }
                  }, {
                    title: _withCtx(() => _cache[28] || (_cache[28] = [
                      _createElementVNode("div", { style: {"display":"flex","height":"32px","align-items":"center"} }, [
                        _createElementVNode("img", {
                          src: _imports_0,
                          style: {"width":"32px","height":"32px"}
                        }),
                        _createTextVNode(),
                        _createElementVNode("label", { style: {"margin-left":"8px","font-size":"16px","font-weight":"500","line-height":"22px"} }, "Original Infomation")
                      ], -1)
                    ])),
                    default: _withCtx(() => [
                      _createVNode(_component_a_descriptions_item, { label: "HTS Code" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.itemData.htsCode), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_descriptions_item, { label: "HTS Description" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_tooltip, {
                            trigger: "click",
                            placement: "topLeft"
                          }, {
                            title: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.itemData.htsDescription), 1)
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.itemData.htsDescription), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_descriptions_item, { label: "PGA" }, {
                        default: _withCtx(() => [
                          (_ctx.itemData.pgaFlags.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemData.pgaFlags, (tag) => {
                                  return (_openBlock(), _createBlock(_component_a_tag, {
                                    key: tag.title,
                                    color: tag.color
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(tag.title), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["color"]))
                                }), 128))
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_36, "-"))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["dataSource"]),
                  _createVNode(_component_a_descriptions, {
                    dataSource: _ctx.itemData,
                    layout: "vertical",
                    size: "small",
                    style: {"margin-top":"8px"},
                    labelStyle: {'color': '#000000A6', 'font-weight' : 400, height: '14px'},
                    contentStyle: { 'display': '-webkit-box', 'font-weight' : 400,'WebkitBoxOrient': 'vertical', 'WebkitLineClamp': 2, 'overflow': 'hidden', 'textOverflow': 'ellipsis' },
                    column: { xxl: 3, xl: 3, lg: 3, md: 3, sm: 2, xs: 1 }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_descriptions_item, { label: "Shipment Description" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.itemData.nameEn), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_descriptions_item, { label: "Shipment Link" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemData.urls, (urlInfo) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: urlInfo.productId,
                                style: {"background-color":"#F1F4FF","display":"inline-block","padding-left":"4px","padding-right":"4px","border-radius":"4px"}
                              }, [
                                _createElementVNode("div", {
                                  onClick: ($event: any) => (_ctx.openLink(urlInfo.productUrl,)),
                                  class: "ship-link"
                                }, [
                                  _createTextVNode(_toDisplayString(urlInfo.nameCn) + " ", 1),
                                  _createVNode(_component_LinkOutlined)
                                ], 8, _hoisted_37)
                              ]))
                            }), 128))
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_descriptions_item, { label: " Description Flag" }, {
                        default: _withCtx(() => [
                          (_ctx.itemData.descriptionFlags.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemData.descriptionFlags, (tag) => {
                                  return (_openBlock(), _createBlock(_component_a_tag, {
                                    key: tag.title,
                                    color: tag.color
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(tag.title), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["color"]))
                                }), 128))
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_39, "-"))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["dataSource"]),
                  _cache[32] || (_cache[32] = _createElementVNode("div", { class: "dashed-line" }, null, -1)),
                  _createElementVNode("div", null, [
                    _cache[29] || (_cache[29] = _createElementVNode("div", { style: {"display":"flex","height":"32px","align-items":"center"} }, [
                      _createElementVNode("img", {
                        src: _imports_1,
                        style: {"width":"32px","height":"32px"}
                      }),
                      _createTextVNode(),
                      _createElementVNode("label", { style: {"margin-left":"8px","font-size":"16px","font-weight":"500","line-height":"22px"} }, "NEW Shipment Description")
                    ], -1)),
                    _createElementVNode("div", _hoisted_40, [
                      (!_ctx.isEditing)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "text-edit-field",
                            onMouseenter: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showEditButton = true)),
                            onMouseleave: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showEditButton = false))
                          }, [
                            _createElementVNode("label", null, _toDisplayString(_ctx.newNameEn), 1),
                            (_ctx.showEditButton)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: _imports_2,
                                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isEditing=true))
                                }))
                              : _createCommentVNode("", true)
                          ], 32))
                        : (_openBlock(), _createBlock(_component_a_input, {
                            key: 1,
                            value: _ctx.newNameEn,
                            "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.newNameEn) = $event)),
                            onPressEnter: _cache[11] || (_cache[11] = ($event: any) => (_ctx.isEditing = false))
                          }, {
                            suffix: _withCtx(() => [
                              _createElementVNode("img", {
                                src: _imports_3,
                                style: {"width":"20px","height":"20px"},
                                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.isEditing = false))
                              })
                            ]),
                            _: 1
                          }, 8, ["value"]))
                    ])
                  ]),
                  _cache[33] || (_cache[33] = _createElementVNode("div", { class: "dashed-line" }, null, -1)),
                  (_ctx.itemData.pgaFlags.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                        _createVNode(_component_a_spin, { spinning: _ctx.loadingSuggest }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_42, [
                              _createVNode(_component_a_checkbox, {
                                checked: _ctx.isRecommend,
                                "onUpdate:checked": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.isRecommend) = $event)),
                                onChange: _ctx.recommendChangeHandle
                              }, {
                                default: _withCtx(() => _cache[30] || (_cache[30] = [
                                  _createTextVNode("Recommended HTS Selection")
                                ])),
                                _: 1
                              }, 8, ["checked", "onChange"])
                            ]),
                            (_ctx.isRecommend)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                  _createVNode(_component_a_spin, { spinning: _ctx.isLoadingRecommend }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_segmented, {
                                        value: _ctx.recommendType,
                                        "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.recommendType) = $event)),
                                        options: _ctx.recommendTypes
                                      }, null, 8, ["value", "options"]),
                                      _createElementVNode("div", _hoisted_44, [
                                        (_ctx.recommendType === 'RTIS')
                                          ? (_openBlock(), _createBlock(_component_a_table, {
                                              key: 0,
                                              dataSource: _ctx.recommendData,
                                              columns: _ctx.recommendColumn,
                                              pagination: false,
                                              size: "small"
                                            }, {
                                              bodyCell: _withCtx(({ column, record }) => [
                                                (column.key === 'radio')
                                                  ? (_openBlock(), _createBlock(_component_a_radio, {
                                                      key: 0,
                                                      checked: _ctx.selectInfo.selectIndex === record.index,
                                                      value: record.index,
                                                      onChange: ($event: any) => (_ctx.onRadioChange(record))
                                                    }, null, 8, ["checked", "value", "onChange"]))
                                                  : _createCommentVNode("", true),
                                                (column.key === 'confidenceLevel')
                                                  ? (_openBlock(), _createBlock(_component_a_progress, {
                                                      key: 1,
                                                      percent: Math.floor(record.confidenceLevel * 100),
                                                      size: "small",
                                                      strokeColor: '#000000'
                                                    }, null, 8, ["percent"]))
                                                  : _createCommentVNode("", true),
                                                (column.key === 'pgaFlags')
                                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                      (record.pgaFlags?.length > 0)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.pgaFlags, (tag) => {
                                                              return (_openBlock(), _createBlock(_component_a_tag, {
                                                                key: tag.title,
                                                                color: tag.color
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createTextVNode(_toDisplayString(tag.title), 1)
                                                                ]),
                                                                _: 2
                                                              }, 1032, ["color"]))
                                                            }), 128))
                                                          ]))
                                                        : (_openBlock(), _createElementBlock("div", _hoisted_46, "-"))
                                                    ], 64))
                                                  : _createCommentVNode("", true),
                                                (column.key === 'htsDescription')
                                                  ? (_openBlock(), _createBlock(_component_a_tooltip, {
                                                      key: 3,
                                                      trigger: "click",
                                                      placement: "topLeft"
                                                    }, {
                                                      title: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(record.htsDescription), 1)
                                                      ]),
                                                      default: _withCtx(() => [
                                                        _createElementVNode("div", _hoisted_47, _toDisplayString(record.htsDescription), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1024))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _: 1
                                            }, 8, ["dataSource", "columns"]))
                                          : (_openBlock(), _createBlock(_component_a_form, {
                                              key: 1,
                                              layout: "vertical",
                                              model: _ctx.htsFormData
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_a_form_item, { label: "New HTS" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_a_input, {
                                                      value: _ctx.htsFormData.htsCode,
                                                      "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.htsFormData.htsCode) = $event)),
                                                      onPressEnter: _ctx.getHtsInfo
                                                    }, {
                                                      suffix: _withCtx(() => [
                                                        _createElementVNode("img", {
                                                          src: _imports_3,
                                                          style: {"width":"20px","height":"20px"},
                                                          onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.getHtsInfo && _ctx.getHtsInfo(...args)))
                                                        })
                                                      ]),
                                                      _: 1
                                                    }, 8, ["value", "onPressEnter"])
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_a_form_item, {
                                                  label: "New HTS Description",
                                                  bordered: false
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_a_textarea, {
                                                      value: _ctx.htsFormData.htsDesc,
                                                      "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.htsFormData.htsDesc) = $event)),
                                                      row: 3,
                                                      readonly: ""
                                                    }, null, 8, ["value"])
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_a_form_item, { label: "PGA" }, {
                                                  default: _withCtx(() => [
                                                    (_ctx.htsFormData.pgaFlags.length > 0)
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.htsFormData.pgaFlags, (tag) => {
                                                            return (_openBlock(), _createBlock(_component_a_tag, {
                                                              key: tag.title,
                                                              color: tag.color
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(tag.title), 1)
                                                              ]),
                                                              _: 2
                                                            }, 1032, ["color"]))
                                                          }), 128))
                                                        ]))
                                                      : (_openBlock(), _createElementBlock("div", _hoisted_49, "-"))
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }, 8, ["model"]))
                                      ])
                                    ]),
                                    _: 1
                                  }, 8, ["spinning"])
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["spinning"])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_50, [
                        _cache[31] || (_cache[31] = _createElementVNode("div", { style: {"display":"flex","height":"32px","align-items":"center"} }, [
                          _createElementVNode("img", {
                            src: _imports_4,
                            style: {"width":"32px","height":"32px"}
                          }),
                          _createTextVNode(),
                          _createElementVNode("label", { style: {"margin-left":"8px","font-size":"16px","font-weight":"500","line-height":"22px"} }, "Replace HTS Code")
                        ], -1)),
                        _createElementVNode("div", _hoisted_51, [
                          _createVNode(_component_a_form, {
                            layout: "vertical",
                            model: _ctx.htsFormData
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, { label: "New HTS" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_input, {
                                    value: _ctx.htsFormData.htsCode,
                                    "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.htsFormData.htsCode) = $event)),
                                    onPressEnter: _ctx.getHtsInfo
                                  }, {
                                    suffix: _withCtx(() => [
                                      (_ctx.htsFormData.htsCode != '')
                                        ? (_openBlock(), _createElementBlock("img", {
                                            key: 0,
                                            src: _imports_3,
                                            style: {"width":"20px","height":"20px"},
                                            onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.getHtsInfo && _ctx.getHtsInfo(...args)))
                                          }))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }, 8, ["value", "onPressEnter"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_form_item, { label: "New HTS Description" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_textarea, {
                                    value: _ctx.htsFormData.htsDesc,
                                    "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.htsFormData.htsDesc) = $event)),
                                    row: 3,
                                    disabled: "",
                                    readonly: ""
                                  }, null, 8, ["value"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_form_item, { label: "PGA" }, {
                                default: _withCtx(() => [
                                  (_ctx.htsFormData.pgaFlags.length > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.htsFormData.pgaFlags, (tag) => {
                                          return (_openBlock(), _createBlock(_component_a_tag, {
                                            key: tag.title,
                                            color: tag.color
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(tag.title), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["color"]))
                                        }), 128))
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_53, "-"))
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["model"])
                        ])
                      ]))
                ]),
                _: 1
              }, 8, ["spinning"])
            ]),
            _: 1
          }, 8, ["open", "onClose"])
        ])
      ])
    ])
  ]))
}